import { ServicesProps } from '@jbhi-fi/apis/src/services/types';
import { dataLayerPushServiceEvent } from '../utils';

export type ProductServiceTrackingProps = {
  service: ServicesProps;
  gtmData: any;
  gtmSource: string;
  trackingMessage?: string;
};

export const ProductServiceTracking = ({
  service,
  gtmData,
  gtmSource,
  trackingMessage,
}: ProductServiceTrackingProps) => {
  const prepareOfferingGtmData = (service: ServicesProps, offeringId?: string) => {
    const offering = offeringId ? service?.offerings?.find(o => o.id === offeringId) : null;
    const { sku, name, priceInc } = offering || {};
    return { sku, name, priceInc };
  };

  //tracking the event when customer clicks an UI element (such as button) of a given service in service listing e.g. carousel
  //which results in customer seeing service details and ability to select/attach the service
  const trackServicePreSelection = (offeringId: string) => {
    const { sku, name, priceInc } = prepareOfferingGtmData(service, offeringId);
    dataLayerPushServiceEvent(
      `${service?.id}.clickextracarebutton`,
      gtmData,
      { sku, name, servicePrice: priceInc },
      gtmSource,
      trackingMessage
    );
  };

  const trackServiceDeselection = (offeringId: string) => {
    const { sku, name, priceInc } = prepareOfferingGtmData(service, offeringId);
    dataLayerPushServiceEvent(`${service?.id}.deselected`, gtmData, { sku, name, servicePrice: priceInc }, gtmSource);
  };

  const trackServiceAddition = (offeringId: string) => {
    const { sku, name, priceInc } = prepareOfferingGtmData(service, offeringId);
    dataLayerPushServiceEvent(
      `${service?.id}.addedandconfirmed`,
      gtmData,
      { sku, name, servicePrice: priceInc },
      gtmSource,
      trackingMessage
    );
  };

  const trackButtonImpression = (offeringId: string) => {
    const { sku, name, priceInc } = prepareOfferingGtmData(service, offeringId);
    dataLayerPushServiceEvent(
      `${service?.id}.button.impression`,
      gtmData.product,
      { sku, name, servicePrice: priceInc },
      gtmData.source
    );
  };

  const trackServiceModalClose = (offeringId: string) => {
    const { sku, name, priceInc } = prepareOfferingGtmData(service, offeringId);
    if (gtmData?.product) {
      dataLayerPushServiceEvent(
        `${service?.id}.closemodal`,
        gtmData.product,
        { sku, name, servicePrice: priceInc },
        gtmData.source
      );
    }
  };

  return {
    trackServicePreSelection,
    trackServiceDeselection,
    trackServiceAddition,
    trackButtonImpression,
    trackServiceModalClose,
  };
};
